<script>
export default {};
</script>

<template>
    <div class="Subheader">
        <span class="Bullet"></span>
        <div class="Inner">
            <slot></slot>
        </div>
    </div>
</template>

<style lang="stylus" scoped>
.Subheader
    font-family Montserrat
    display flex
    align-items center
    justify-content flex-start
    flex-wrap no-wrap
    text-transform uppercase
    color #181834
    font-weight 700
    font-size 12px
    margin 30px 0
    .Bullet
        height 8px
        width 8px
        border-radius 50%
        background #2FFAE6
        margin 0 20px 0 0
    .Inner
        position relative
        display flex
        align-items center
        justify-content flex-start
        flex-wrap no-wrap
        span
            color #ccc
    &.Simple
        .Bullet
            display none
</style>


